<div class="main-container">
  <section class="logo-container">
    <cp-logo></cp-logo>
  </section>

  <section class="back-last-update-container">
    <div class="go-back-container">
      <go-back (click)="back()"></go-back>
    </div>
  </section>

  <section class="form-container" [formGroup]="form">
    <div class="inner-conainer">
      <H2>Set Password</H2>
      <div class="input-container">
        <label for="">Old Password</label>
        <gbui-input
          class="input-password"
          password
          formControlName="oldPassword"
          placeholder="Password"
        ></gbui-input>
      </div>
      <div class="input-container">
        <label for="">New Password</label>
        <gbui-input
          class="input-password"
          password
          formControlName="newPassword"
          placeholder="Password"
          [ngClass]="{
            'invalid-input':
              !form.controls['newPassword'].valid &&
              form.controls['newPassword'].touched
          }"
        ></gbui-input>
        <label
          class="scale-up-ver-top"
          *ngIf="
            !form.controls['newPassword'].valid &&
            form.controls['newPassword'].touched
          "
        >
          {{ getPasswordErrorMessage('newPassword') }}
        </label>
      </div>
      <div class="input-container">
        <label for="">Confirm Password</label>
        <gbui-input
          class="input-password"
          password
          formControlName="confirmPassword"
          placeholder="Confirm Password"
          [ngClass]="{
            'invalid-input':
              !form.controls['confirmPassword'].valid &&
              form.controls['confirmPassword'].touched
          }"
        ></gbui-input>
        <label
          class="scale-up-ver-top"
          *ngIf="
            !form.controls['confirmPassword'].valid &&
            form.controls['confirmPassword'].touched
          "
        >
          {{ getPasswordErrorMessage('confirmPassword') }}
        </label>
      </div>
    </div>
  </section>

  <section class="button-container">
    <gbui-button
      [disabled]="form.invalid"
      simple
      [busy]="updatePasswordLoading$ | async"
      class="buttons-outline"
      (click)="updatePassword()"
      >Update</gbui-button
    >
  </section>

</div>
